module.exports = __webpack_public_path__ + "img/v1-research.d3dfff68.png";